<div
    class="flex justify-between items-start p-6 bg-white border-t border-[#E7EAF0] space-y-2 cursor-pointer hover:bg-[#F6F7FF]"
    [ngClass]="notificationSignal()?.isRead ? '' : 'bg-[#F6F7FF]'"
    (click)="handleClick()">
    <div class="flex items-center w-full gap-3">
        <div
            class="h-12 w-12 rounded-full flex items-center justify-center"
            [ngClass]="`notification-icon-${getNotificationTypeIcon(notificationSignal()?.type).color}`">
            <img alt="Notification" class="h-6 w-6" [src]="getNotificationTypeIcon(notificationSignal()?.type).icon" />
        </div>

        <div class="flex flex-col gap-[5px]">
            <p class="text-[#0A0A0A] text-[0.875rem]" [innerHTML]="notificationSignal()?.message"></p>
            <p class="text-[0.875rem] text-[#717182]">{{ timeAgo(notificationSignal()?.createdAt!) }}</p>
        </div>
        @if (!notificationSignal()?.isRead) {
            <p
                class="text-xs text-[#717182] font-medium ml-auto mt-auto cursor-pointer hover:underline"
                (click)="handleRead(); $event.stopPropagation()">
                Dismiss
            </p>
        }
    </div>
</div>
